import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

const RoleGuard = ({ allowedRoles, children }) => {
    const [isAllowed, setIsAllowed] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                try {
                    const token = await currentUser.getIdTokenResult();
                    if (allowedRoles.includes(token.claims.role)) {
                        setIsAllowed(true);
                    } else {
                        setIsAllowed(false);
                    }
                } catch (error) {
                    console.error("Error checking role:", error);
                    setIsAllowed(false);
                }
            } else {
                setIsAllowed(false);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [allowedRoles]);

    if (loading) {
        return <div className="loading-screen">Loading...</div>; 
    }

    if (!isAllowed) {
        alert("You are not authorized to access this page");
        return <Navigate to="/" replace />;
    }

    return children;
};

export default RoleGuard;
